export var TransactionType;
(function (TransactionType) {
    TransactionType["Buy"] = "Buy";
    TransactionType["Sell"] = "Sell";
    TransactionType["Withdrawal"] = "Withdrawal";
    TransactionType["Deposit"] = "Deposit";
    TransactionType["BonusClaim"] = "BonusClaim";
})(TransactionType || (TransactionType = {}));
//# sourceMappingURL=transaction.js.map